import { render, staticRenderFns } from "./SchoolTeam.vue?vue&type=template&id=000b8282&scoped=true&"
import script from "./SchoolTeam.vue?vue&type=script&lang=js&"
export * from "./SchoolTeam.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeam.vue?vue&type=style&index=0&id=000b8282&lang=less&scoped=true&"
import style1 from "./SchoolTeam.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b8282",
  null
  
)

export default component.exports